import { render, staticRenderFns } from "./Setting_bSales.vue?vue&type=template&id=8eace6ba"
import script from "./Setting_bSales.vue?vue&type=script&lang=js"
export * from "./Setting_bSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports